import { Col, ConfigProvider, Pagination, Row, TableColumnsType, Tabs, Tag, Tooltip, Typography } from 'antd';
import React, { useEffect, useMemo, useState } from 'react';
import TierBenefits from '../../pages/CustomerService/MemberCard/ComponentAddRank/TierBenefits';
import './CustomerResultCard.scss';
import OverViewCardCustomer from './OverViewCardCustomer';

import { CrownOutlined } from '@ant-design/icons';
import { ColDef } from 'ag-grid-community';
import { SearchProps } from 'antd/es/input';
import viVN from 'antd/locale/vi_VN';
import { IListHistoryLog } from '../../api/Customer_V2/customerApi_V2';
import * as BenefitApi from '../../api/rank/benefitApi';
import * as RankApi from '../../api/rank/rankApi';
import { NO_DATA, URL_RANK } from '../../env';
import useLoading from '../../hook/useLoading';
import useToast from '../../hook/useToast';
import HistoryCard from '../../pages/CustomerService/MemberCard/ComponentAddRank/HistoryCard';
import { capitalizeEachWord, formatDateToDMY, formatPrice, genderLinkForLogV4 } from '../../until';
import { Card_Loyalty_02, none_rank } from '../ExportImgFigma';
import OverViewCardCustomerV2 from './OverViewCardCustomerV2';
import ProgressItemCard from './ProgressItemCard';

type TabKey = "overview" | "rank" | "policy" | "benefit" | "history";

interface ITabState<T = any> {
    loaded: boolean;
    data: T[];
    total: number;
}


interface props {
    dataCardCustomer: RankApi.ISearchCardCustomer
}

interface ITabState<T = any> {
    loaded: boolean;
    data: T[];
    total: number;
}

const CustomerResultCard: React.FC<props> = ({
    dataCardCustomer
}) => {

    const pushToast = useToast();
    const pushLoading = useLoading()

    const nextRankInfo = dataCardCustomer?.nextRankInfo ?? []
    const infoCustomer = dataCardCustomer?.infoCustomer ?? []

    const [searchValue, setSearchValue] = useState<string>('');
    const [searchValuePolicies, setSearchValuePolicies] = useState<string>('');
    const [searchValueRankPolicies, setSearchValueRankPolicies] = useState<string>('');
    const [searchValueHistoryCard, setSearchValueHistoryCard] = useState<string>('');

    const [tabState, setTabState] = useState<Record<TabKey, ITabState>>({
        overview: {
            loaded: true,
            data: [],
            total: 0,
        },
        rank: {
            loaded: false,
            data: [],
            total: 0,
        },
        policy: {
            loaded: false,
            data: [],
            total: 0,
        },
        benefit: {
            loaded: false,
            data: [],
            total: 0,
        },
        history: {
            loaded: false,
            data: [],
            total: 0,
        },
    });


    // gộp pagination
    const [activeTab, setActiveTab] = useState<TabKey>("overview");

    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0,
    });

    const updateTabState = (
        tab: TabKey,
        data: any[],
        total: number,
    ) => {
        setTabState(prev => ({
            ...prev,
            [tab]: {
                loaded: true,
                data,
                total,
            },
        }));
    };
    const onTabChange = (key: string) => {

        const tab = key as TabKey;

        setActiveTab(tab);
    };



    const onSearch: SearchProps['onSearch'] = (value, _e, info) => {
        setSearchValue(value);
        loadData("rank", 1, pagination.pageSize, true);
    }

    const onSearchPolicies: SearchProps['onSearch'] = (value, _e, info) => {
        setSearchValuePolicies(value);
        loadData("policy", 1, pagination.pageSize, true);
    }

    const onSearchRankPolicies: SearchProps['onSearch'] = (value, _e, info) => {
        setSearchValueRankPolicies(value);
        loadData("benefit", 1, pagination.pageSize, true);
    }

    const onSearchHistoryCard: SearchProps['onSearch'] = (value, _e, info) => {
        setSearchValueHistoryCard(value);
        loadData("history", 1, pagination.pageSize, true);
    }

    const columns: TableColumnsType<BenefitApi.DataTypeBenefit> = [

        {
            title: 'STT',
            dataIndex: 'stt',
            align: 'center',
            sorter: {
                compare: (a, b) => a.stt - b.stt,
                multiple: 1,
            },
        },
        {
            title: 'Mã quyền lợi',
            dataIndex: 'code',
            render: (text) => (
                <div className="t-name-ql">
                    <span className="neutral-gray-500 text-2-row">{text}</span>
                </div>
            ),
        },
        {
            title: 'Tên quyền lợi',
            dataIndex: 'title',
            render: (text) => (
                <div className="t-name-ql">
                    <div className="icon-svg"><CrownOutlined /></div>
                    <span className="neutral-gray-500">{text}</span>
                </div>
            ),
        },
        {
            title: 'Mô tả quyền lợi dễ hiểu',
            dataIndex: 'description',
        },
    ];
    const columnsPolicies: TableColumnsType<BenefitApi.DataTypeBenefit> = [
        {
            title: 'STT',
            dataIndex: 'stt',
            align: 'center',
            sorter: {
                compare: (a, b) => a.stt - b.stt,
                multiple: 1,
            },
        },
        {
            title: 'Mã quyền lợi',
            dataIndex: 'code',
            render: (text) => (
                <div className="t-name-ql">
                    <span className="neutral-gray-500 text-2-row">{text}</span>
                </div>
            ),
        },
        {
            title: 'Tên quyền lợi',
            dataIndex: 'title',
            render: (text) => (
                <div className="t-name-ql">
                    <div className="icon-svg"><CrownOutlined /></div>
                    <span className="neutral-gray-500">{text}</span>
                </div>
            ),
        },
        {
            title: 'Mô tả quyền lợi dễ hiểu',
            dataIndex: 'description',
        },
    ];

    const columnsRankPolicies: TableColumnsType<BenefitApi.DataTypeBenefit> = [
        {
            title: 'STT',
            dataIndex: 'stt',
            align: 'center',
            sorter: {
                compare: (a, b) => a.stt - b.stt,
                multiple: 1,
            },
        },
        {
            title: 'Mã quyền lợi',
            dataIndex: 'code',
            render: (text) => (
                <div className="t-name-ql">
                    <span className="neutral-gray-500 text-2-row">{text}</span>
                </div>
            ),
        },
        {
            title: 'Tên quyền lợi',
            dataIndex: 'title',
            render: (text) => (
                <div className="t-name-ql">
                    <div className="icon-svg"><CrownOutlined /></div>
                    <span className="neutral-gray-500">{text}</span>
                </div>
            ),
        },
        {
            title: 'Mô tả quyền lợi dễ hiểu',
            dataIndex: 'description',
            render: (text) => (
                <Tooltip
                    title={text}
                    color="#fff"
                    styles={{
                        body: {
                            color: "#000",
                        },
                    }}
                >
                    <Typography.Paragraph
                        className=' font-regular'
                        ellipsis={{ rows: 2 }}
                        style={{ marginBottom: 0, fontSize: 16, color: '#667085' }}
                    >
                        {text}
                    </Typography.Paragraph>
                </Tooltip>
            ),
        },
        {
            title: 'Ngày bắt đầu',
            dataIndex: 'dateStart',
        },
        {
            title: 'Ngày kết thúc',
            dataIndex: 'dateEnd',
        },
    ];



    const columnDefs: ColDef<IListHistoryLog>[] = useMemo(() => [
        {
            headerName: 'Họ và tên nhân viên',
            width: 220,
            cellRenderer: (params: { data?: IListHistoryLog }) => {
                return params.data?.fullname ?? NO_DATA;
            },
        },
        {
            headerName: 'Email',
            width: 280,
            cellStyle: {
                color: '#666666',
                paddingLeft: '16px',
                paddingRight: '16px',
            },
            cellRenderer: (params: { data?: IListHistoryLog }) => {
                return params.data?.email ?? NO_DATA;
            },
        },
        {
            headerName: 'Thời gian',
            width: 180,
            cellStyle: {
                color: '#666666',
                paddingLeft: '16px',
                paddingRight: '16px',
            },
            cellRenderer: (params: { data?: IListHistoryLog }) => {
                const [date, time] = params.data?.createdAt.split(" ") ?? []
                const dateTmp = formatDateToDMY(date ?? "")
                return dateTmp ? (time + " " + dateTmp) : NO_DATA;
            },

        },
        {
            headerName: 'Hành động',
            flex: 1,
            minWidth: 350,
            cellStyle: {
                color: '#333333',
                paddingLeft: '16px',
                paddingRight: '16px',
            },
            cellRenderer: (params: { data?: IListHistoryLog }) => {
                return <Tooltip
                    placement="right"
                    color="white"
                    title={
                        <div className="custom-page-css flex flex-col gap-1" style={{ color: "#000" }}>
                            {params?.data?.HistorySummaries?.map((item, i) => (
                                <div key={i}>{item.description}</div>
                            ))}
                        </div>
                    }
                >
                    <span className="custom-page-css " >
                        {genderLinkForLogV4(params?.data?.HistorySummaries[0])}
                    </span>
                </Tooltip>
            },
        },
    ], [tabState.history.data]);




    const loadData = async (
        tab: TabKey,
        page = pagination.current,
        pageSize = pagination.pageSize,
        force = false,
    ) => {
        if (!force && tabState[tab].loaded) {

            setPagination(prev => ({
                ...prev,
                current: page,
                pageSize,
                total: tabState[tab].total,
            }));

            return;
        }

        switch (tab) {

            case "rank": {

                const result =
                    await BenefitApi.getListBenefitsByCustomer(
                        infoCustomer.customerId,
                        pageSize,
                        page,
                        searchValue
                    );

                if (!result.status) return;

                updateTabState(
                    "rank",
                    convertData(result.data),
                    result.total,
                );

                break;
            }

            case "policy": {

                const result =
                    await RankApi.getListCarePoliciesByCustomer(
                        infoCustomer.customerId,
                        pageSize,
                        page,
                        searchValueRankPolicies
                    );

                if (!result.status) return;

                updateTabState(
                    "policy",
                    convertDataV2(result.data),
                    result.total,
                );

                break;
            }

            case "benefit": {

                const result =
                    await BenefitApi.getListBenefitPoliciesByCustomer(
                        infoCustomer.customerId,
                        pageSize,
                        page,
                        searchValuePolicies
                    );

                if (!result.status) return;

                updateTabState(
                    "benefit",
                    convertData(result.data),
                    result.total,
                );

                break;
            }

            case "history":
                const result =
                    await BenefitApi.getListHistoryCardIssuance(
                        infoCustomer.customerId,
                        pageSize,
                        page,
                        searchValueHistoryCard
                    );

                if (!result.status) return;

                updateTabState(
                    "history",
                    result.data,
                    result.total,
                );
                break;
        }

        setPagination(prev => ({
            ...prev,
            current: page,
            pageSize,
            total: tabState[tab].total,
        }));
    };


    const convertData = (data: BenefitApi.IBenefit[] | RankApi.IRankPolicie[]) => {
        var stt = 1;
        const convertData = data.map((item) => ({
            key: item.id,
            stt: stt++,
            code: item.code,
            title: item.title,
            description: item?.description,
            // status: item?.status
        }))
        return convertData
    }

    const convertDataV2 = (data: RankApi.IRankPolicie[]) => {
        var stt = 1;
        const convertData = data.map((item) => ({
            key: item.id,
            stt: stt++,
            code: item.code,
            title: item.title,
            description: item?.benefitPolicyNames,
            dateStart: item?.dateStart,
            dateEnd: item?.dateEnd,
            // status: item?.status
        }))
        return convertData
    }

    useEffect(() => {
        loadData(activeTab, 1);
    }, [activeTab]);


    return (
        <div
            className='custom-page-css flex flex-col gap-2 w-full h-full'
        >
            <Row gutter={16}>
                <Col span={8} >
                    <div className="custom-page-css relative  overflow-hidden rounded p-4"
                        style={{
                            minHeight: 280,
                            backgroundImage: `url(${Card_Loyalty_02})`,
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                            backgroundRepeat: "no-repeat",
                        }}

                    >

                        {/* <span className='custom-page-css text-344054 font-regular text-sm text-italic'></span> */}
                        <div className="member-card__content custom-page-css flex flex-col gap-2">
                            <Tag className="member-tag">
                                <div className="">
                                    <img
                                        style={{
                                            width: 22,
                                            height: 22,
                                            objectFit: 'cover'
                                        }}
                                        src={URL_RANK + infoCustomer.rankIcon}
                                        alt=""
                                        onError={(e) => {
                                            e.currentTarget.src = none_rank;
                                        }}
                                    />
                                </div>
                                <span className='font-regular text-white  text-sm w-fit'>{infoCustomer?.rankTitle}</span>
                            </Tag>
                            <span className='custom-page-css text-white font-medium text-base'>    {infoCustomer.code}</span>
                            <div className="custom-page-css flex flex-col">
                                <span className='custom-page-css text-FFC53D font-medium text-base uppercase'>
                                    {capitalizeEachWord(infoCustomer.username)}
                                </span>
                                <span className='custom-page-css text-white font-medium text-base'>    {infoCustomer.listPhone[0]}
                                </span>
                            </div>

                        </div>

                        {/* type ===1 => chi tiêu tích luỹ */}
                        {/* Chưa đủ điều kiện */}
                        {
                            nextRankInfo?.type === 1 && !nextRankInfo.isHighestRank &&

                            <ProgressItemCard
                                title="Tổng chi tiêu tích lũy "
                                description={nextRankInfo?.message}
                                percent={(nextRankInfo?.customerTotalAmount ?? 0) / nextRankInfo?.totalAmount * 100}
                            />

                        }

                        {/* đã đạt rank cao nhất*/}
                        {
                            nextRankInfo?.type === 1 && nextRankInfo.isHighestRank &&

                            <div className="highest-rank-item  pt-4">
                                <div className="custom-page-css highest-rank-title text-white">Tổng chi tiêu tích lũy </div>

                                <div className="custom-page-css highest-rank-status text-white">
                                    {nextRankInfo?.message}
                                </div>

                                <div className="custom-page-css highest-rank-amount text-white">
                                    {formatPrice(nextRankInfo?.customerTotalAmount)} đ
                                </div>
                            </div>
                        }

                        {/* type ===3 => chi tiêu dịch vụ && xe */}
                        {/* Đủ điều kiện */}
                        {
                            nextRankInfo?.type === 2 && !nextRankInfo.isHighestRank &&

                            <>
                                <ProgressItemCard
                                    title="Tổng chi tiêu mua xe "
                                    description={nextRankInfo?.purchase.message}
                                    percent={(nextRankInfo?.purchase.customerTotalPurchaseAmount ?? 0) / nextRankInfo?.purchase.totalPurchaseAmount * 100}
                                />

                                <ProgressItemCard
                                    title="Tổng chi tiêu dịch vụ "
                                    description={nextRankInfo?.service.message}
                                    percent={(nextRankInfo?.service.customerTotalServiceAmount ?? 0) / nextRankInfo?.service.totalServiceAmount * 100}
                                />
                            </>
                        }

                        {/* đã đạt rank cao nhất */}
                        {
                            nextRankInfo?.type === 2 && nextRankInfo.isHighestRank &&

                            <>
                                <div className="highest-rank-item pt-2">
                                    <div className="custom-page-css highest-rank-title text-white">Tổng chi tiêu mua xe </div>

                                    <div className="custom-page-css highest-rank-status text-white">
                                        {nextRankInfo?.purchase.message}
                                    </div>

                                    <div className="custom-page-css highest-rank-amount text-white">
                                        {formatPrice(nextRankInfo?.purchase.customerTotalPurchaseAmount)} đ
                                    </div>
                                </div>
                                <div className="custom-page-css highest-rank-item  pt-4 text-white">
                                    <div className="highest-rank-title">Tổng chi tiêu dịch vụ </div>

                                    <div className="custom-page-css highest-rank-status text-white">
                                        {nextRankInfo?.service.message}
                                    </div>

                                    <div className="custom-page-css highest-rank-amount text-white">
                                        {formatPrice(nextRankInfo?.service.customerTotalServiceAmount)} đ
                                    </div>
                                </div>
                            </>
                        }
                    </div>
                </Col>

                <Col span={16}>
                    <OverViewCardCustomer
                        dataCardCustomer={dataCardCustomer}
                    />
                </Col>
            </Row>

            <Tabs
                activeKey={activeTab}
                onChange={onTabChange}
                items={[
                    {
                        key: "overview",
                        label: "Tổng quan",
                        children:
                            <OverViewCardCustomerV2
                                dataCardCustomer={dataCardCustomer}
                            />
                    },
                    {
                        key: "rank",
                        label: "Quyền lợi hạng",
                        children: <TierBenefits
                            title="Tìm quyền lợi"
                            dataBenefit={tabState.rank.data}
                            onSearch={onSearch}
                            columns={columns}
                        />
                    },
                    {
                        key: "policy",
                        label: "Chính sách CSKH",
                        children:
                            <TierBenefits
                                title="Tìm quyền lợi"
                                dataBenefit={tabState.policy.data}
                                onSearch={onSearchRankPolicies}
                                columns={columnsRankPolicies}
                            />
                    },
                    {
                        key: "benefit",
                        label: "Quyền lợi chính sách CSKH",
                        children: <TierBenefits
                            title="Tìm quyền lợi"
                            dataBenefit={tabState.benefit.data}
                            onSearch={onSearchPolicies}
                            columns={columnsPolicies}
                        />
                    },
                    {
                        key: "history",
                        label: "Lịch sử",
                        children: <HistoryCard
                            title="Tìm tên hoạt động"
                            data={tabState.history.data}
                            onSearch={onSearchHistoryCard}
                            columns={columnDefs}
                        />


                        // <HistoryTab />
                    }
                ]}
            />


            <div className="custom-page-css w-full flex justify-center pt-2 mt-auto">
                <ConfigProvider locale={viVN}>
                    <div className="pagination-block">
                        <Pagination
                            current={pagination.current}
                            pageSize={pagination.pageSize}
                            total={pagination.total}
                            showSizeChanger
                            showQuickJumper
                            onChange={(page, pageSize) => {
                                loadData(activeTab, page, pageSize, true);
                            }}
                        />
                    </div>
                </ConfigProvider>
            </div>
        </div>
    )
}

export default CustomerResultCard
